module.exports = __webpack_public_path__ + "media/images/cpc_finish-1afa4536.svg";